import Vue from 'vue'
import Vuex from 'vuex'
import axios from 'axios' // remove comment if yu needed
import Crud from '../crud'
import app from '../../main' // import the instance
import checkResponse from '@/utils/checkResponse'

Vue.use(Vuex)

const model = (payload) => ({
  // columns
  id: payload.id,
  title: payload.title,
  desc: payload.desc,
  foliable_type: payload.foliable_type,
  foliable_id: payload.foliable_id,
  customer_id: payload.customer_id,
  supplier_id: payload.supplier_id,
  start_date: payload.start_date,
  end_date: payload.end_date,
  assign_to_ids: payload.assign_to_ids,
  users: payload.users,
  file: payload.file,
  created_by_id: payload.created_by_id,
  user_id: payload.user_id,
  comment_text: payload.comment,
  comment_id: payload.comment_id
})
var crud = new Crud('Tasks', model)

Vue.use(Vuex)

const state = {
  ...crud.state,
  tasks: [],
  task: {},
  catalog: {
    users: [],
    purchaseOrders: [],
    quotations: [],
    sales: [],
    suppliers: [],
    customers: []
  },
  comments: []
}

const mutations = {
  ...crud.mutations,
  ADD_RECORD (state, payload) {
    if (payload.users.some(user => user.id === app.$auth.user().id)) {
      state.tasks.unshift(payload)
    }
  },

  ADD_ATTACHEMNT (state, payload) {
    const task = state.tasks.findIndex(u => u.id === payload.id)
    if (task >= 0) {
      Vue.set(state.tasks, task, payload)
    }
  },
  CURRENT_TASK (state, payload) {
    state.task = payload
  },
  UPDATE_COMMENTS (state, payload) {
    state.comments = payload
  },
  DELETE_COMMENT_TASK_DETAIL (state, payload) {
    const idx = state.comments.findIndex(u => u.id === payload)

    if (idx >= 0) {
      Vue.delete(state.comments, idx)
    }
  },
  ADD_COMMENT (state, payload) {
    state.comments.unshift(payload[0])
  }
}

const actions = {
  ...crud.actions,
  async addRecord ({ commit }, payload) {
    app.$Progress.start()
    commit('SET_LOADING', true, { root: true })
    try {
      const response = await axios.post(`tasks`, payload)
      const checkErrors = checkResponse(response)

      if (checkErrors) {
        app.$Progress.fail()
        commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'errors.connection_error', text: checkErrors.message }, { root: true })
      } else {
        commit('ADD_RECORD', response.data)
        commit('SET_ACCEPT_ALERT', { color: 'success', title: 'strings.attachments', text: 'front.added_successfully', icon: 'checkmark-circle-outline' }, { root: true })
      }
    } catch (e) {
      app.$Progress.fail()
      commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'errors.connection_error', text: 'errors.generic_error' }, { root: true })
    } finally {
      app.$Progress.finish()
      commit('SET_LOADING', false, { root: true })
    }
  },
  async editRecord ({ commit }, payload) {
    app.$Progress.start()
    commit('SET_LOADING', true, { root: true })
    try {
      const response = await axios.put(`tasks/${payload.id}`, payload)
      const checkErrors = checkResponse(response)

      if (checkErrors) {
        app.$Progress.fail()
        commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'errors.connection_error', text: checkErrors.message }, { root: true })
      } else {
        commit('UPDATE_RECORD', response.data)
        commit('SET_MODAL_VISIBLE', false)
        commit('SET_ACCEPT_ALERT', { color: 'success', title: 'strings.' + 'task', text: 'front.updated_successfully', icon: 'checkmark-circle-outline' }, { root: true })
      }
    } catch (e) {
      app.$Progress.fail()
      commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'errors.connection_error', text: 'errors.generic_error' }, { root: true })
    } finally {
      app.$Progress.finish()
      commit('SET_LOADING', false, { root: true })
    }
  },
  async addTaskAttachment ({ commit }, payload) {
    app.$Progress.start()
    commit('SET_LOADING', true, { root: true })
    let formData = new FormData()
    formData.append('file', payload.file)

    try {
      const response = await axios.post(`tasks/${payload.id}/attachments`, formData)
      const checkErrors = checkResponse(response)

      if (checkErrors) {
        app.$Progress.fail()
        commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'errors.connection_error', text: checkErrors.message }, { root: true })
      } else {
        commit('ADD_ATTACHEMNT', response.data)
      }
    } catch (e) {
      app.$Progress.fail()
      commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'errors.connection_error', text: 'errors.generic_error' }, { root: true })
    } finally {
      app.$Progress.finish()
      commit('SET_LOADING', false, { root: true })
    }
  },
  async editTaskAttachment ({ commit }, payload) {
    app.$Progress.start()
    commit('SET_LOADING', true, { root: true })
    let formData = new FormData()
    formData.append('file', payload.file)

    try {
      const response = await axios.put(`tasks/${payload.id}/attachments/${payload.file.id}`, formData)
      const checkErrors = checkResponse(response)

      if (checkErrors) {
        app.$Progress.fail()
        commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'errors.connection_error', text: checkErrors.message }, { root: true })
      } else {
        commit('ADD_ATTACHEMNT', response.data)
      }
    } catch (e) {
      app.$Progress.fail()
      commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'errors.connection_error', text: 'errors.generic_error' }, { root: true })
    } finally {
      app.$Progress.finish()
      commit('SET_LOADING', false, { root: true })
    }
  },
  async loadComments ({ commit }, payload) {
    try {
      const response = await axios.get(`tasks/${payload.id}/comments`, payload)
      const checkErrors = checkResponse(response)

      if (checkErrors) {
        app.$Progress.fail()
        commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'errors.connection_error', text: checkErrors.message }, { root: true })
      } else {
        commit('UPDATE_COMMENTS', response.data)
      }
    } catch (e) {
      app.$Progress.fail()
      commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'errors.connection_error', text: 'errors.generic_error' }, { root: true })
    } finally {
      app.$Progress.finish()
      commit('SET_LOADING', false, { root: true })
    }
  },
  async markSeenTask ({ commit }, payload) {
    try {
      app.$Progress.start()
      commit('SET_LOADING', true, { root: true })
      const response = await axios.put(`task/${payload.id}/seen`, payload)
      const checkErrors = checkResponse(response)

      if (checkErrors) {
        app.$Progress.fail()
        commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'errors.connection_error', text: checkErrors.message }, { root: true })
      } else {
        commit('UPDATE_RECORD', response.data)
        commit('CURRENT_TASK', response.data)
      }
    } catch (e) {
      app.$Progress.fail()
      commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'errors.connection_error', text: 'errors.generic_error' }, { root: true })
    }
  },
  async addComment ({ commit }, payload) {
    try {
      app.$Progress.start()
      commit('SET_LOADING', true, { root: true })
      const response = await axios.post(`tasks/${payload.id}/comments`, payload)
      const checkErrors = checkResponse(response)

      if (checkErrors) {
        app.$Progress.fail()
      } else {
        console.log(response.data)
        commit('ADD_COMMENT', response.data)
      }
    } catch (e) {
      app.$Progress.fail()
      commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'errors.connection_error', text: 'errors.generic_error' }, { root: true })
    } finally {
      app.$Progress.finish()
      commit('SET_LOADING', false, { root: true })
    }
  },
  async deleteComment ({ commit }, payload) {
    try {
      const response = await axios.delete(`tasks/${payload.id}/comments/${payload.comment_id}`, payload)
      const checkErrors = checkResponse(response)

      if (checkErrors) {
        app.$Progress.fail()
        commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'errors.connection_error', text: checkErrors.message }, { root: true })
      } else {
        commit('DELETE_COMMENT_TASK_DETAIL', payload.comment_id)
        commit('SET_MODAL_VISIBLE', false)
      }
    } catch (e) {
      app.$Progress.fail()
      commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'errors.connection_error', text: 'errors.generic_error' }, { root: true })
    } finally {
      app.$Progress.finish()
      commit('SET_LOADING', false, { root: true })
    }
  },
  async download ({ commit }, payload) {
    app.$Progress.start()
    commit('SET_LOADING', true, { root: true })
    try {
      window.open(`${Vue.axios.defaults.baseURL}/attachments/${payload.id}/download`)
    } catch (error) {
      app.$Progress.fail()
    } finally {
      app.$Progress.finish()
      commit('SET_LOADING', false, { root: true })
    }
  }
}

const getters = {
  ...crud.getters,
  tasks: state => state.tasks,
  catalog: state => state.catalog,
  comments: state => state.comments,
  task: state => state.task
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}
